import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getRiskFactors = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/risk_factor/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Risk data fetch error:", error);
    throw error;
  }
};

const editRiskFactor = async (factor_id, points) => {
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/risk_factor/`,
      {
        factor_id,
        points,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );

    return res;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};

const deletetRiskFactor = async (factor_id) => {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/risk_factor/`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        data: {
          factor_id,
        },
      },
    );

    return res;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};

export { getRiskFactors, editRiskFactor, deletetRiskFactor };
